import { render, staticRenderFns } from "./PowerConsumptionReport.vue?vue&type=template&id=644debb8&"
import script from "./PowerConsumptionReport.vue?vue&type=script&lang=js&"
export * from "./PowerConsumptionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports